import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "_metronic/_helpers";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-top: 5rem;
    text-align: center;
    font-size: 14px;
`;

const TextDanger = styled.div`
    color: ${colors.danger[700]};
    margin: 4rem 0;
`;

const TextItalic = styled.div`
    color: ${colors.passive[500]};
    margin-bottom: 3rem;
    font-style: italic;
`;

const TextPassive = styled.div`
    color: ${colors.passive[500]};
    margin-top: 1rem;
`;

function ExtensionNotice() {
    return (
        <Container>
            <SVG src={toAbsoluteUrl("/media/l3rn-tech/L3RNTechBlack.svg")} height={36} />
            <TextDanger>L3RN.tech extension is out of service.</TextDanger>
            <TextItalic>No panic, L3RN.tech is still working.</TextItalic>
            <ButtonWithText
                variant="l3rnTech"
                buttonStyle="default"
                size="small"
                as={"a"}
                href="/"
                target="_blank"
                onClick={() => {}}
            >
                Click Here
            </ButtonWithText>
            <TextPassive>to continue using the L3RN.tech.</TextPassive>
        </Container>
    );
}

export default ExtensionNotice;
